import { MetaData } from '@xing-com/crate-lebenslauf-components';
import { useIsCrateApp } from '@xing-com/crate-lebenslauf-hooks';
import { Frame } from '@xing-com/crate-lebenslauf-xinglets';
import type { Xinglet } from '@xing-com/crate-xinglet';

import { CoverLetter } from './cover-letter';

const lebenslaufTitle =
  'Erstelle professionelle Bewerbungsanschreiben in Minuten';
const lebenslaufDescription =
  'Erstelle mit unserem einfach zu bedienenden Bewerbungseditor professionelle Anschreiben, die Personalverantwortliche beeindrucken.';
const xingTitle = 'Bewerbungsanschreiben leicht gemacht - Vorlagen inklusive';
const xingDescription =
  'Erstelle mit unserem intuitiven Bewerbungseditor maßgeschneiderte Anschreiben, die deine Persönlichkeit und Qualifikationen präsentieren.';

export default class CoverLetterXinglet implements Xinglet {
  public getComponent() {
    return () => {
      const isCrateApp = useIsCrateApp();

      return (
        <Frame hideFooter noMainContentWrapperStyles isEditorPage>
          <MetaData
            title={isCrateApp ? xingTitle : lebenslaufTitle}
            description={isCrateApp ? xingDescription : lebenslaufDescription}
          />
          <CoverLetter />
        </Frame>
      );
    };
  }
}
